<body class="location-admin">
  <app-table-header
    [headerText]="headerText"
    [hasRadioButton]="hasRadioButton"
    [radioHeader]="radioHeader"
    [firstOptionValue]="firstOptionValue"
    [firstOptionName]="firstOptionName"
    [secondOptionValue]="secondOptionValue"
    [secondOptionName]="secondOptionName"
    [radioModel]="radioModel"
    [filterDisabled]="!isFilterEnabled"
    [hasAddItem]="isAdminSearch && canAddLocations"
    [rightPadding]="7"
    (exportRadioButtonChange)="emitRadioButtonChange($event)"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addLocation()"
  ></app-table-header>
  <div class="location-admin-table-container">
    <!-- Table -->
    <table mat-table class="location-admin-table" [dataSource]="dataSource">
      <!-- Location Code -->
      <ng-container matColumnDef="locationCode">
        <th mat-header-cell *matHeaderCellDef class="location-code-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_CODE"
            [control]="locationCodeData.formControl"
            [maxLength]="10"
            [textInputWidth]="120"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="location-headers"
          class="left-data-column"
        >
          {{ admin.locationCode }}
        </td>
      </ng-container>

      <!-- Location Name -->
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef class="location-name-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_NAME"
            [control]="locationNameData.formControl"
            [maxLength]="30"
            [textInputWidth]="140"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.SPACE"
            [searchIconOffset]="37"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="location-name-headers"
          class="left-data-column"
        >
          {{ admin.locationName }}
        </td>
      </ng-container>

      <!-- Port Code -->
      <ng-container matColumnDef="portCode">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="header"
          class="portCode-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.PORT_CODE"
            [control]="portCodeData.formControl"
            [maxLength]="5"
            [textInputWidth]="100"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="portCode-headers"
        >
          {{ admin.portCode }}
        </td>
      </ng-container>

      <!-- PKG SLIC -->
      <ng-container matColumnDef="pkgSlic">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.PACKAGE_SLIC"
            [control]="packageSlicData.formControl"
            [maxLength]="5"
            [textInputWidth]="72"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_NUMBER"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="pkg-slic-headers"
          class="left-data-column"
        >
          {{ admin.pkgSlic }}
        </td>
      </ng-container>

      <!-- Country -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef id="small-header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.COUNTRY"
            [control]="countryData.formControl"
            [maxLength]="2"
            [textInputWidth]="72"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.ALPHABET_ONLY"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="country-headers"
          class="left-data-column"
        >
          {{ admin.country }}
        </td>
      </ng-container>

      <!-- Region -->
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef id="small-header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.REGION"
            [control]="regionData.formControl"
            [maxLength]="2"
            [textInputWidth]="72"
            [searchIconOffset]="17"
            [allowedSpecialChars]="SPECIAL_CHARS.NUMBER_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="region-headers"
          class="right-data-column"
        >
          {{ admin.region }}
        </td>
      </ng-container>

      <!-- District -->
      <ng-container matColumnDef="district">
        <th mat-header-cell *matHeaderCellDef id="small-header">
          <app-table-search-component
            [columnName]="COLUMNTEXT.DISTRICT"
            [control]="districtData.formControl"
            [maxLength]="2"
            [textInputWidth]="72"
            [searchIconOffset]="17"
            [allowedSpecialChars]="SPECIAL_CHARS.NUMBER_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="district-headers"
          class="right-data-column"
        >
          {{ admin.district }}
        </td>
      </ng-container>

      <!--Time Zone-->
      <ng-container matColumnDef="timeZone">
        <th mat-header-cell *matHeaderCellDef class="timezone-headers">
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.TIME_ZONE"
            [itemId]="timeZoneData.itemId"
            [searchResults]="timeZoneDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            [textInputWidth]="220"
            [popoverStyle]="{ maxWidth: 225, offsetX: -175 }"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, timeZoneData)
            "
          >
          </app-table-header-dropdown>
        </th>
        <td
          mat-cell
          *matCellDef="let location"
          headers="timezone-headers"
          class="timezone-column-data"
        >
          {{ location.timeZone }}
        </td>
      </ng-container>

      <!--Group Code-->
      <ng-container matColumnDef="locationGroups">
        <th mat-header-cell *matHeaderCellDef class="location-group-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_GROUPS_CODE"
            [control]="locationGroupsData.formControl"
            [maxLength]="5"
            [textInputWidth]="100"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          class="groups"
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="group-code-headers"
        >
          {{ admin.locationGroups.toString() }}
        </td>
      </ng-container>

      <!-- Messaging -->
      <ng-container matColumnDef="messaging">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.MESSAGING"
            [data]="messagingData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[1]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
            "
            (emitStatusChange)="
              onStatusChangeForDropdowns($event, messagingData)
            "
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="messaging-headers"
        >
          @if (location.messaging === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- API key -->
      <ng-container matColumnDef="apiKey">
        <th mat-header-cell *matHeaderCellDef id="header">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.API_KEY"
            [data]="apiKeyData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="72"
            [showDropdown]="dropdownOpen[2]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 2)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, apiKeyData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let location; let i = index"
          headers="api-key-headers"
        >
          @if (location.apiKey === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else if (location.apiKey === false) {
            <img alt="false" [src]="IMAGES.CANCEL" />
          } @else {}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="action-headers">
          <ion-row class="th-text"> {{ CONSTS.ACTIONS }} </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="action-headers"
        >
          <!-- delete operation is still a WIP for back-end and will be disabled until work is completed -->
          <!-- will be set by role from this context -->
          <app-table-action-cell
            [data]="admin"
            [hasDeleteButton]="false"
            [hasEditButton]="true"
            [editButtonDisabled]="!canEditDeleteLocation"
            [deleteButtonDisabled]="true"
            (emitEditButton)="editLocation(admin, i)"
          ></app-table-action-cell>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
      ></tr>
      <tr class="mat-row no-data-row" *matNoDataRow>
        <td
          class="mat-cell no-border message"
          [attr.colspan]="displayedColumns.length"
        >
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
